import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import resetPasswordService from '../services/resetPasswordService'
import SubmitButton from './commonUIComponents/SubmitButton'

const ResetPasswordPage = () => {
  const { uuid } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods
  const password = methods.watch('password')

  useEffect(() => {
    resetPasswordService.validateResetPasswordToken(uuid)
      .then(res => console.log('Checking token ...'))
      .catch(err => {
        enqueueSnackbar(err.response?.data?.message, { variant: 'warning' })
        navigate('/login')
      })
  }, [])

  const submitHandler = values => {
    console.log(methods.watch('password'))
    const formValues = {
      uuid,
      newPassword: values.password
    }
    console.log(formValues)
    return resetPasswordService.resetPassword(formValues)
      .then(res => {
        enqueueSnackbar('Successfully updated the password', { variant: 'success' })
        navigate('/login')
      })
      .catch(err => enqueueSnackbar(err.response?.data?.message, { variant: 'warning' }))
  }

  return (
    <>
      <Box>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitHandler)}>
            <Grid container spacing={2}>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <Card variant="outlined">
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h5" component="div">
                          Choose a new password
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2">
                          Reset your password and choose a new password
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Password"
                          type="password"
                          {...register('password',
                            {
                              required: {
                                value: true,
                                message: 'Invalid Password'
                              }
                            }
                          )}
                          error={errors.password}
                          helperText={errors.password?.message}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Confirm new password"
                          type="password"
                          {...register('confirmPassword',
                            {
                              required: {
                                value: true,
                                message: 'Invalid Password'
                              },
                              validate: value => {
                                if (password !== value) { return 'Passwords do not match' }
                              }
                            }
                          )}
                          error={errors.confirmPassword}
                          helperText={errors.confirmPassword?.message}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <SubmitButton buttonLabel="Continue" loadingLabel="Resetting ..." />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} />
            </Grid>
          </form>
        </FormProvider>
      </Box>
    </>
  )
}

export default ResetPasswordPage
